import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { Roboto_Mono } from "next/font/google";
import { DimensionEventStatus } from "@dimensional-engineering/dimensional-models";

import styles from "./RecommendedAssessment.module.css";

import { RootState } from "@/redux/store";
import {
  dimensionCompletedTimes,
  dimensionData,
  dimensionIcons,
} from "@/assets/traitInfo/dimensionData";

const font = Roboto_Mono({ subsets: ["latin"] });

export default function RecommendedAssessment(props: { slug: string }) {
  const router = useRouter();
  const userState = useSelector((state: RootState) => state.user);
  const icon = dimensionIcons[props.slug].icon;

  const dimension = dimensionData?.find(
    (d) => d.slug === props.slug || d.longFormSlug === props.slug
  );
  const userDimension = userState.dimensionEvents?.find(
    (d) => d.dimensionSlug === props.slug
  );

  const longFormDimension = userState.dimensionEvents?.find(
    (d) => d.dimensionSlug === dimension?.longFormSlug
  );

  const status =
    userDimension && userDimension.event === DimensionEventStatus.started
      ? "Continue"
      : userDimension && userDimension.event === DimensionEventStatus.complete
      ? "Retake"
      : "Start";

  const longFormStatus =
    longFormDimension &&
    longFormDimension.event === DimensionEventStatus.started
      ? "Continue"
      : longFormDimension &&
        longFormDimension.event === DimensionEventStatus.complete
      ? "Retake"
      : "Start";

  const estimatedCompletionTime: number =
    dimensionCompletedTimes[props.slug as keyof typeof dimensionCompletedTimes];

  return (
    <div
      style={{
        backgroundImage: `url(/dimensions/backgrounds/${props.slug}.jpg)`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      className={styles.main}
    >
      <p className={styles.topText}>Continue your journey</p>
      <div className={styles.iconDiv}>{icon}</div>
      <h1>{dimension?.title}</h1>
      <div className={styles.estimates}>
        <p className={font.className}>
          {estimatedCompletionTime} min. {dimension?.numElements} elements
        </p>
      </div>
      <h3>{dimension?.description}</h3>
      <button
        className={styles.startButton}
        onClick={() => router.push(`/app/assessment/${props.slug}`)}
      >
        {longFormDimension ? longFormStatus : status} Dimension
      </button>
    </div>
  );
}
